export default "__VITE_ASSET__Bg_1N55r__"